var Account, ActionFactories, Config, getAccountPromise, getGalleryPromise, loadGallery, m, nonJsonErrors;

m = require('mithril');

ActionFactories = require('./ActionFactories');

Config = require('../lib/Config');

nonJsonErrors = function(xhr) {
  if (xhr.status >= 400) {
    return JSON.stringify(xhr.responseText);
  } else {
    return xhr.responseText;
  }
};

getAccountPromise = function(name) {
  return m.request({
    method: 'GET',
    url: (Config.FilesBaseUrl()) + "/accounts/" + name + ".js",
    extract: nonJsonErrors
  });
};

getGalleryPromise = function(id) {
  return m.request({
    method: 'GET',
    url: (Config.FilesBaseUrl()) + "/galleries/" + id + ".js",
    extract: nonJsonErrors
  });
};

loadGallery = function(store, galleryId) {
  return getGalleryPromise(galleryId).then(function(gallery) {
    gallery.photos.sort(function(a, b) {
      if (a.timestamp.epoch < b.timestamp.epoch) {
        return -1;
      }
      if (a.timestamp.epoch > b.timestamp.epoch) {
        return +1;
      }
      return 0;
    });
    store.dispatch(ActionFactories.galleryLoaded(gallery));
    return gallery;
  });
};

Account = {
  loadAccount: function(store, name) {
    return getAccountPromise(name).then(function(account) {
      store.dispatch(ActionFactories.accountLoaded(account));
      return account;
    }).then(function(account) {
      var galleryId, i, len, ref, ref1;
      ref1 = (ref = account.galleryIds) != null ? ref : [];
      for (i = 0, len = ref1.length; i < len; i++) {
        galleryId = ref1[i];
        loadGallery(store, galleryId);
      }
      return account;
    });
  },
  getGallery: function(galleries, galleryId) {
    var gallery, ref;
    if (galleries == null) {
      galleries = [];
    }
    return (ref = ((function() {
      var i, len, results;
      results = [];
      for (i = 0, len = galleries.length; i < len; i++) {
        gallery = galleries[i];
        if (gallery.id === galleryId) {
          results.push(gallery);
        }
      }
      return results;
    })())[0]) != null ? ref : null;
  },
  getPhoto: function(galleries, galleryId, photoName) {
    var gallery, photo, ref;
    if (galleries == null) {
      galleries = [];
    }
    gallery = Account.getGallery(galleries, galleryId);
    if (gallery === null) {
      return null;
    }
    return (ref = ((function() {
      var i, len, ref1, results;
      ref1 = gallery.photos;
      results = [];
      for (i = 0, len = ref1.length; i < len; i++) {
        photo = ref1[i];
        if (photo.name === photoName) {
          results.push(photo);
        }
      }
      return results;
    })())[0]) != null ? ref : null;
  }
};

module.exports = Account;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvc3RhdGUvQWNjb3VudC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy9zdGF0ZS9BY2NvdW50LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFFSixlQUFBLEdBQWtCLE9BQUEsQ0FBUSxtQkFBUjs7QUFDbEIsTUFBQSxHQUFTLE9BQUEsQ0FBUSxlQUFSOztBQUVULGFBQUEsR0FBZ0IsU0FBQyxHQUFEO0VBQ2YsSUFBRyxHQUFHLENBQUMsTUFBSixJQUFjLEdBQWpCO1dBRUMsSUFBSSxDQUFDLFNBQUwsQ0FBZSxHQUFHLENBQUMsWUFBbkIsRUFGRDtHQUFBLE1BQUE7V0FJQyxHQUFHLENBQUMsYUFKTDs7QUFEZTs7QUFPaEIsaUJBQUEsR0FBb0IsU0FBQyxJQUFEO1NBQ25CLENBQUMsQ0FBQyxPQUFGLENBQVU7SUFBQyxNQUFBLEVBQVEsS0FBVDtJQUFnQixHQUFBLEVBQU8sQ0FBQyxNQUFNLENBQUMsWUFBUCxDQUFBLENBQUQsQ0FBQSxHQUF1QixZQUF2QixHQUFtQyxJQUFuQyxHQUF3QyxLQUEvRDtJQUFxRSxPQUFBLEVBQVMsYUFBOUU7R0FBVjtBQURtQjs7QUFHcEIsaUJBQUEsR0FBb0IsU0FBQyxFQUFEO1NBQ25CLENBQUMsQ0FBQyxPQUFGLENBQVU7SUFBQyxNQUFBLEVBQVEsS0FBVDtJQUFnQixHQUFBLEVBQU8sQ0FBQyxNQUFNLENBQUMsWUFBUCxDQUFBLENBQUQsQ0FBQSxHQUF1QixhQUF2QixHQUFvQyxFQUFwQyxHQUF1QyxLQUE5RDtJQUFvRSxPQUFBLEVBQVMsYUFBN0U7R0FBVjtBQURtQjs7QUFHcEIsV0FBQSxHQUFjLFNBQUMsS0FBRCxFQUFRLFNBQVI7U0FDYixpQkFBQSxDQUFrQixTQUFsQixDQUNDLENBQUMsSUFERixDQUNPLFNBQUMsT0FBRDtJQUNMLE9BQU8sQ0FBQyxNQUFNLENBQUMsSUFBZixDQUFvQixTQUFDLENBQUQsRUFBRyxDQUFIO01BQ25CLElBQWEsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxLQUFaLEdBQW9CLENBQUMsQ0FBQyxTQUFTLENBQUMsS0FBN0M7QUFBQSxlQUFPLENBQUMsRUFBUjs7TUFDQSxJQUFhLENBQUMsQ0FBQyxTQUFTLENBQUMsS0FBWixHQUFvQixDQUFDLENBQUMsU0FBUyxDQUFDLEtBQTdDO0FBQUEsZUFBTyxDQUFDLEVBQVI7O0FBQ0EsYUFBTztJQUhZLENBQXBCO0lBSUEsS0FBSyxDQUFDLFFBQU4sQ0FBZSxlQUFlLENBQUMsYUFBaEIsQ0FBOEIsT0FBOUIsQ0FBZjtXQUNBO0VBTkssQ0FEUDtBQURhOztBQVVkLE9BQUEsR0FBVTtFQUNULFdBQUEsRUFBYSxTQUFDLEtBQUQsRUFBUSxJQUFSO1dBQ1osaUJBQUEsQ0FBa0IsSUFBbEIsQ0FDQyxDQUFDLElBREYsQ0FDTyxTQUFDLE9BQUQ7TUFDTCxLQUFLLENBQUMsUUFBTixDQUFlLGVBQWUsQ0FBQyxhQUFoQixDQUE4QixPQUE5QixDQUFmO2FBQ0E7SUFGSyxDQURQLENBSUMsQ0FBQyxJQUpGLENBSU8sU0FBQyxPQUFEO0FBQ0wsVUFBQTtBQUFBO0FBQUEsV0FBQSxzQ0FBQTs7UUFBQSxXQUFBLENBQVksS0FBWixFQUFtQixTQUFuQjtBQUFBO2FBQ0E7SUFGSyxDQUpQO0VBRFksQ0FESjtFQVVULFVBQUEsRUFBWSxTQUFDLFNBQUQsRUFBaUIsU0FBakI7QUFDWCxRQUFBOztNQURZLFlBQVk7Ozs7Ozs7Ozs7Ozs4QkFDNkM7RUFEMUQsQ0FWSDtFQWFULFFBQUEsRUFBVSxTQUFDLFNBQUQsRUFBaUIsU0FBakIsRUFBNEIsU0FBNUI7QUFDVCxRQUFBOztNQURVLFlBQVk7O0lBQ3RCLE9BQUEsR0FBVSxPQUFPLENBQUMsVUFBUixDQUFtQixTQUFuQixFQUE4QixTQUE5QjtJQUNWLElBQWUsT0FBQSxLQUFXLElBQTFCO0FBQUEsYUFBTyxLQUFQOzs7Ozs7Ozs7Ozs7OzhCQUNzRTtFQUg3RCxDQWJEOzs7QUFtQlYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
